import { render, staticRenderFns } from "./DoctorPosterPopular.vue?vue&type=template&id=65cdce7a&scoped=true&"
import script from "./DoctorPosterPopular.vue?vue&type=script&lang=js&"
export * from "./DoctorPosterPopular.vue?vue&type=script&lang=js&"
import style0 from "./DoctorPosterPopular.vue?vue&type=style&index=0&id=65cdce7a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65cdce7a",
  null
  
)

export default component.exports